import { Grid, MenuItem, TextField } from "@mui/material";
import { Controller } from "react-hook-form";

export function ControlledSelect(props) {
    return (
        <Controller
            control={props.control}
            name={props.name}
            render={({ field }) => (
                <Grid item>
                    <TextField
                        {...field}
                        disabled={props.disabled}
                        select
                        label={props.label}
                        size="small"
                        fullWidth
                        sx={props.sx}
                    >
                        {props.data?.map((entry, idx) =>
                            entry.render ? (
                                entry.render()
                            ) : (
                                // @ts-ignore
                                <MenuItem key={idx} value={entry.value}>
                                    {entry.label}
                                </MenuItem>
                            ),
                        )}
                    </TextField>
                </Grid>
            )}
        />
    );
}

export function ControlledDynamicSelect(props) {
    return (
        <Controller
            control={props.control}
            name={props.name}
            render={({ field }) => (
                <Grid item>
                    <TextField {...field} select label={props.label} size="small" fullWidth>
                        {props.data.map((entry, idx) =>
                            entry.render ? (
                                entry.render()
                            ) : (
                                // @ts-ignore
                                <MenuItem key={idx} value={entry.value}>
                                    {entry.label}
                                </MenuItem>
                            ),
                        )}
                    </TextField>
                </Grid>
            )}
        />
    );
}
